import { IntlProvider, MessageFormatElement } from 'react-intl'
import { DEFAULT_UI_LANGUAGE_VALUE } from '../../constants'
import { useTranslationData } from '../../contexts'
import {
  getFrontPageLinkTranslationsForLang,
  getTextTranslationsForLang
} from '../../utils'
import { WrapperProps } from '../types'
import { CustomTranslationsData } from './types'

interface CustomTranslationsWrapperNewProps extends WrapperProps {
  customTranslationsData: CustomTranslationsData
}

export const CustomTranslationsWrapperNew = ({
  children,
  customTranslationsData
}: CustomTranslationsWrapperNewProps) => {
  const { UILanguage, localizedOptionsLists, localizedNews } =
    useTranslationData()

  const languageKey = UILanguage || DEFAULT_UI_LANGUAGE_VALUE

  const { translations, links, configTranslations } = customTranslationsData

  const localizedMessages = getTextTranslationsForLang(
    languageKey,
    translations,
    links
  )

  const localizedLinks = {
    localizedLinkList: getFrontPageLinkTranslationsForLang(languageKey, links)
  }

  const localizedBusinessLanguagesOptions = {
    localizedBusinessLanguageList:
      configTranslations.businessLanguages[languageKey]
  }

  const localizedPaymentOptions = {
    localizedPaymentOptionList: configTranslations.paymentOptions[languageKey]
  }

  const messages = Object.assign(
    localizedMessages,
    localizedOptionsLists,
    localizedBusinessLanguagesOptions,
    localizedPaymentOptions,
    localizedLinks,
    localizedNews
  ) as Record<string, MessageFormatElement[]>

  return (
    <IntlProvider locale={UILanguage} messages={messages}>
      {children}
    </IntlProvider>
  )
}
